import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { setName } from '../redux/lists'

export default function * requestChangeListName (action) {
  const { id, name } = action.payload

  const optimisticAction = yield optimisticPut(setName({
    id,
    name
  }))

  try {
    yield call(apiAction, 'RenameVList', {
      id,
      name
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
